import { Controller } from 'stimulus';
import { EMAIL_REGEX, PHONE_REGEX } from './constants';

export default class extends Controller {

  static targets = [ "button"]

  initialize() {
    if (document.getElementById('thank-you-modal')){
      openModal('#thank-you-modal')
    }

    this.showOrHideInputBoxes();
  }

  showOrHideInputBoxes() {
    const emailCheckbox = document.getElementById('review_email_checkbox').checked;
    const phoneCheckbox = document.getElementById('review_phone_checkbox').checked;

    document.getElementById('user-review-email').classList.toggle('hidden', !emailCheckbox);
    document.getElementById('user-review-phone-area-code').classList.toggle('hidden', !phoneCheckbox);
  }

  toggle(event) {
    let acknowledged_at;
    let checkbox = document.getElementById(event.target.value);
    if (!checkbox.checked) {
      checkbox.checked = !checkbox.checked;
      checkbox.disabled = true;
      acknowledged_at = new Date().toUTCString();
      let formData = new FormData();
      formData.append('acknowledged_at', acknowledged_at);

      fetch(this.data.get('update-url'), {
        body: formData,
        method: 'PATCH',
        credentials: 'include',
        dataType: 'script',
        headers: {
          'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
        },
      })
        .then((response) => {
          if (response.status != 200) {
            checkbox.checked = !checkbox.checked;
            checkbox.disabled = false;
          } else {
            let referral = document.getElementById('not_contacted_referrals_' + event.target.value);
            let contacted_referrals = document.getElementById('contacted_referrals');
            contacted_referrals.prepend(referral);
            checkbox.setAttribute('title', 'can not uncheck already marked referral');
          }
          return response.text();
        })
        .then((data) => {
          let response = JSON.parse(data);
          document.getElementById('referral_count').innerHTML = response.referrals_count + ' ' + response.text;
          if (response.message != undefined) {
            this.flash_message(response.message);
          }
        });
    } else {
      this.flash_message('Cannot perform this action');
    }
  }

  flash_message(message) {
    document.getElementById('notice-container').innerHTML = '<p class="alert">' + message + '</p>';
    setTimeout(() => $('p.alert').addClass('fade-out'), 5000);
  }

  clearFormFields() {
    document.querySelector('#new_referral').reset();
    document.getElementById('referral_personalized_message').placeholder = `Provide an introduction to [first_name] to understand why ${this.data.get('user')} is great`
    document.getElementsByClassName('info')[0].innerText = `Great Recruiters will send an email to [first_name] with ${this.data.get('user')}'s Information so they can contact.`
    if (window.location.hash === "#refer-a-friend") {
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }
  }

  changeText() {
    let first_name = document.getElementById('first_name').value
    document.getElementById('referral_personalized_message').placeholder = `Provide an introduction to ${first_name} to understand why ${this.data.get('user')} is great`
    document.getElementsByClassName('info')[0].innerText = `Great Recruiters will send an email to ${first_name} with ${this.data.get('user')}'s Information so they can contact.`
  }

  validate_candidate_email_phone_validity(event)
  {
    if (event.target.id === 'review_phone_checkbox') {
      document.getElementById('user-review-phone-area-code').classList.toggle('hidden');
    }

    if (event.target.id === 'review_email_checkbox') {
      document.getElementById('user-review-email').classList.toggle('hidden');
    }

    this.validate_phone_presence()
    this.validate_email_presence();
  }

  validate_email_presence() {
    const emailCheckbox = document.getElementById('review_email_checkbox').checked;
    const emailInput = document.getElementById('review_candidate_email');

    emailInput.required = emailCheckbox;
    emailInput.style.display = emailCheckbox ? 'block' : 'none';
    emailInput.value = emailCheckbox ? emailInput.value : '';

    const emailValue = emailInput.value.trim();
    if (emailValue !== '' && !EMAIL_REGEX.test(emailValue)) {
      return false;
    }

    return true;
  }

  validate_phone_presence() {
    const phoneCheckbox = document.getElementById('review_phone_checkbox').checked;
    const phoneWrapper  = document.getElementById('user-review-phone-area-code');
    const phoneInput =  document.getElementById('review_candidate_phone');

    phoneInput.required = phoneCheckbox;
    phoneWrapper.style.display = phoneCheckbox ? 'block' : 'none';
    phoneInput.value = phoneCheckbox ? phoneInput.value : '';
  }

  validate(event) {
    this.validation(event.currentTarget.id.split('_'));
  }

  validation(index) {
    let count, name, email, job_title;
    count = parseInt(index[index.length -1]);
    name = document.getElementById(`candidate_name_` + `${count}`);
    email = document.getElementById(`candidate_email_` + `${count}`);
    job_title = document.getElementById(`candidate_job_title_` + `${count}`);
    const inputsNotEmpty = (name.value.trim() + email.value.trim() + job_title.value.trim()).length > 0;
    name.required = email.required = job_title.required = inputsNotEmpty;
  }

  userReferralModal() {
    $("#referred-job-id").attr('disabled','disabled');
  }

  jobReferralModal()
  {
    $("#referred-job-id").removeAttr('disabled');
  }


  connect() {
    this.initializeReferralModal();
    window.addEventListener('hashchange', this.handleHashChange.bind(this));
  }

  initializeReferralModal() {
    const button = this.buttonTarget;
    button.addEventListener('click', () => {
      const currentUrl = window.location.href;
      if (!currentUrl.includes("#refer-a-friend")) {
        const referralUrl = currentUrl + '#refer-a-friend';
        window.history.pushState(null, null, referralUrl);
      }
    });

    if (window.location.href.includes("refer-a-friend")) {
      $('#referral-modal').click();
    }
  }
  handleHashChange() {
   this.initializeReferralModal();
  }

  validate_referral_email_phone(email_phone_value) {
    return EMAIL_REGEX.test(email_phone_value) || PHONE_REGEX.test(email_phone_value);
  }

  async CopyURL(event) {
    event.preventDefault();
    var url = event.currentTarget.dataset['target'];
    var dummy = document.createElement('input'),
    text = window.location.href;
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    var copy_alert = $('#url-copy');
    copy_alert.fadeIn('slow');
    copy_alert.fadeOut(5000);
  }
}
